import { CogOffOutlineIcon } from './CogOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 83E26995-9267-4A7B-8271-885FEF6303D8
 * name cog-off-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-off-outline.svg
 * tags
 * - Settings 
 */
export const SettingsOffOutlineIcon = CogOffOutlineIcon;
export default SettingsOffOutlineIcon